import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { EntityModel } from '@data-layer/models/entities';
import { enumEntityModelCode } from '@data-layer/enums/entities/enumEntityCode';

/** Customs-broker entity CRUD — mirrors the user-side EntitiesRepository on the customs-broker prefix. */
@Injectable({
  providedIn: 'root',
})
export class EntitiesCustomsBrokerManagementRepository {
  constructor(private apiService: ApiService) {}

  public get(entityId: number): Observable<EntityModel> {
    return this.apiService.get<EntityModel>(`${environment.url.prefixCustoms}v2/management/customs-broker/entities/${entityId}`);
  }

  public create(companyId: number, data: Partial<EntityModel>): Observable<EntityModel> {
    return this.apiService.post<EntityModel>(
      `${environment.url.prefixCustoms}v2/management/customs-broker/companies/${companyId}/entities`,
      data,
    );
  }

  public update(entityId: number, data: Partial<EntityModel>): Observable<EntityModel> {
    return this.apiService.put<EntityModel>(`${environment.url.prefixCustoms}v2/management/customs-broker/entities/${entityId}`, data);
  }

  public delete(entityId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/management/customs-broker/entities/${entityId}`);
  }

  public searchByCompany(
    companyId: number,
    params: {
      type: enumEntityModelCode;
      name?: string;
      identifier?: string;
    },
    isUsed: boolean = false,
  ): Observable<EntityModel[]> {
    return this.apiService.get(
      `${environment.url.prefixCustoms}v2/management/customs-broker/companies/${companyId}/entities`,
      { params },
      { isShowLoader: false, isUsed },
    );
  }
}
